import { HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Arrays } from "../util/arrays";

/**
 * 페이징 모델
 */
export class PageResult<T> {
  totalPages: number = 1;
  totalElements: number = 0;
  number: number = 0;
  size: number = environment.config.pageSize;
  content: any[] = [];

  first: boolean = true;
  last: boolean = false;
  next: boolean = false;
  previous: boolean = false;

  private instance: new (...args: any) => T;

  constructor(pageResult?: any, instance?: new (...args: any) => T) {
    this.bind(pageResult, instance);
  }

  public bind(pageResult?: any, instance?: new (...args: any) => T) {
    Object.assign(this, pageResult || {});

    if (instance) this.instance = instance;

    let list: T[] = Arrays.isNotEmpty(this.content) ? (instance != null ? pageResult.content.map((element: any) => new instance(element)) : pageResult.content) : [];

    this.content = list;
  }

  public toPageable(): HttpParams {
    return new HttpParams().set('page', String(this.number)).set('size', String(this.size));
  }
}
